
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sostenibilita/certificazioni",
      function () {
        return require("private-next-pages/sostenibilita/certificazioni/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sostenibilita/certificazioni"])
      });
    }
  